import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";

import * as api from "../../api/api";
import { useUser } from "../../contexts/user_provider";
import AppSelector from "../AppSelector";

export default function AddAppModal({
    organizationId,
    locationId,
    mission,
    show,
    hide,
}) {
    const { getUserIsAdmin } = useUser();
    const [selectedApps, setSelectedApps] = React.useState([]);

    async function addApps() {
        if (!mission || !selectedApps.length) return;

        const newApps = selectedApps.filter(
            (appId) => !mission.apps.some((app) => app.id === appId),
        );

        for (const appId of newApps) {
            try {
                await api.addAppToMission(
                    organizationId,
                    locationId,
                    mission.id,
                    appId,
                );
            } catch (err) {
                console.error(`Failed to add app ${appId}:`, err);
            }
        }

        hide();
    }

    return (
        getUserIsAdmin() && (
            <Modal show={show} onHide={hide}>
                <Modal.Header closeButton>
                    <Modal.Title>Add app</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AppSelector
                        usedApps={mission.apps.filter(
                            (app) => app?.type !== "background",
                        )}
                        value={selectedApps}
                        onChange={(apps) => setSelectedApps(apps)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={hide}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={addApps}
                        disabled={!selectedApps.length}
                    >
                        <FaPlus
                            className="me-2"
                            style={{ marginTop: "-2px" }}
                        />
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    );
}
